import { render, staticRenderFns } from "./TreeNode.vue?vue&type=template&id=4ecdbfd0&scoped=true"
import script from "./TreeNode.vue?vue&type=script&lang=js"
export * from "./TreeNode.vue?vue&type=script&lang=js"
import style0 from "./TreeNode.vue?vue&type=style&index=0&id=4ecdbfd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecdbfd0",
  null
  
)

export default component.exports